<template>
  <div class="progress-bar" :style="{ height: height, backgroundColor: backgroundColor }">
    <div class="fill" :style="{ width: `${progress}%`, background: gradient }" />
  </div>
</template>

<script setup>
import { watch } from 'vue'

const props = defineProps({
  progress: {
    type: Number,
    required: true
  },
  gradient: {
    type: String,
    default: 'linear-gradient(270deg, #7a71f9, #8a83f5)'
  },
  backgroundColor: {
    type: String,
    default: '#f3f3f3'
  },
  height: {
    type: String,
    default: '20px'
  }
})

const emit = defineEmits(['onComplete'])

watch(
  () => props.progress,
  (newProgress) => {
    if (newProgress >= 100) {
      emit('onComplete')
    }
  }
)
</script>

<style scoped lang="scss">
.progress-bar {
  width: 100%;
  border-radius: 30px;
  overflow: hidden;
}

.fill {
  height: 100%;
  background-size: 200% 100%;
  transition: width 0.3s;
  max-width: 100%;
  @include animation(gradientShift 3s infinite ease-in-out);
}

@include keyframes(gradientShift) {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
